const APP_IDENTIFIER_HEADER = 'x-phoenix-app-id';
/**
 * @ngdoc provider
 * @name phoenix.appIdentifier.pxAppIdentifierInterceptor
 *
 * @description
 * Provider for configuring the appIdInterceptorFactory before it is created.
 * If the provider is not used to configure the interceptor factory, it will
 * default to providing an interceptor for ShareBase.
 */
export function AppIdInterceptorProvider() {
    let appId: string = 'ShareBase';

    return {
        /**
         * @ngdoc method
         * @name pxAppIdentifierInterceptorProvider#setAppId
         * @methodOf phoenix.appIdentifier.pxAppIdentifierInterceptorProvider
         * @kind function
         *
         * @description
         * Set the app id that will be used in the pxAppIdentifierInterceptor
         *
         * @param {String} val The value to use as the app id.
         */
        setAppId,
        /**
         * @ngdoc method
         * @name pxAppIdentifierInterceptorProvider#$get
         * @methodOf phoenix.appIdentifier.pxAppIdentifierInterceptorProvider
         * @kind function
         *
         * @description
         * Used to resolve the 'pxAppIdentifierInterceptor' service. Used by
         * angular's injector.
         */
        $get: getInterceptor
    };

    function setAppId(val) {
        appId = val;
    }

    function getInterceptor() {
        return appIDInterceptorFactory(appId);
    }
}

/**
 * @ngdoc service
 * @name phoenix.appIdentifier.pxAppIdentifierInterceptor
 *
 * @description
 * An http interceptor that adds an app id header to each request.
 * The app id is retrieved from the settings service and included
 * in each request to the API.
 */
function appIDInterceptorFactory(appId:string) {

    return {
        /**
         * @ngdoc method
         * @name pxAppIdentifierInterceptor#request
         * @methodOf phoenix.appIdentifier.pxAppIdentifierInterceptor
         * @kind function
         *
         * @description
         * Adds x-phoenix-app-id header to each request if there is an app id provided.
         */
        request: addIdToRequest
    };

    function addIdToRequest(config:ng.IRequestConfig): ng.IRequestConfig {
        if (appId) {
            config.headers[APP_IDENTIFIER_HEADER] = appId;
        }
        return config;
    }
}


// WEBPACK FOOTER //
// ./src/phoenix/Interceptors/appIdentifierInterceptor.ts